import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ValidateOneDecimal(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const oneDecimalRegEx = /^(?!0$)(\d{1,3}|\.\d|\d{1,3}\.\d)$/g;
    if (control.value !== 0 && !oneDecimalRegEx.test(control.value)) {
      return {
        valid: false,
      };
    }
    return null;
  };
}

export function CustomDecimalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;
    const regex = /^(?:0(?:\.\d{1,2})?|\d{1,4}(?:\.\d{1,2})?)$/;
    if (value && !regex.test(value)) {
      return {
        invalidFormat: true,
      };
    }
    return null;
  };
}

// This function are not allowed DOT[.] , DOT Zero [.0] and integer DOT[xxx.] else allows all the values even null
export function DecimalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;
    const oneDecimalRegExFollowingNumber = /^(?!\.$)(?!\.0$)(?!.*\.$)(?!.*\.0$).*$|^$/;
    if (value && !oneDecimalRegExFollowingNumber.test(value)) {
      return {
        invalidFormat: true,
      };
    }
    return null;
  };
}

export function negativedecimalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;

    // Handle cases where value is null or undefined
    if (value === null || value === undefined || value === '') {
      return null; // No validation error for empty values (handled separately if required)
    }
    const valueStr = String(value);
    if (valueStr === '-0') {
      return {

        invalidFormat: true,
      };
    }

    const wholeNumberRegex = /^-?\d{1,5}$/; // Max 5 whole number digits
    const decimalNumberRegex = /^-?\d{1,5}(\.\d{1,2})?$/; // Max 2 decimal places
    // const decimalRegex = /^-?\d{1,5}(\.\d{0,2})?$/;
    // Prevent trailing decimal (e.g., "99999." is invalid)
    if (valueStr.endsWith('.')) {
      return {
        invalidFormat: true,
      };
    }

    // if (!decimalRegex.test(valueStr) || valueStr.length > 7) {
    //   return {
    //     invalidFormat: true,
    //   };
    // }
    const isWholeNumber = /^-?\d{6,}$/.test(valueStr);
    if (isWholeNumber) {
      return {
        invalidFormat: true,
      };
    }
    // Validate against regex
    const isDecimal = valueStr.includes('.');
    const isValid = isDecimal
      ? decimalNumberRegex.test(valueStr) && valueStr.length <= 7
      : wholeNumberRegex.test(valueStr) && valueStr.length <= 5;

    if (!isValid) {
      return {
        invalidFormat: true,
      };
    }
    return null;
  };
}

export function DepthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value.trim();

    if (!value) return null;
    // Regex for single decimal format, including negative values (e.g., -0, -4.33, 4.33)
    const singleDecimalPattern = /^-?([0-9]+(\.[0-9]{1,2})?)$/;
    // Regex for the decimal range format (e.g., -4.33-3.33, 1-2, but NOT -2--3)
    const decimalRangePattern = /^-?([0-9]+(\.[0-9]{1,2})?)-(-?[0-9]+(\.[0-9]{1,2})?)$/;

    // Regex for the "stockpile" word (case insensitive)
    const stockpilePattern = /^stockpile$/i;

    // Validate if it matches one of the allowed formats
    if (singleDecimalPattern.test(value) || decimalRangePattern.test(value) || stockpilePattern.test(value)) {
      return null; // Valid
    }

    return {
      invalidDepthFormat: true,
    }; // Invalid format
  };
}
